package com.wintermar.inspection.navigation

enum class RoutePath(val path: String) {
    INSPECTION("/inspection"),
    TEMPLATE("/template")
}
